























































import { Vue, Component, Prop } from 'vue-property-decorator';
import DroppoLogo from "@/views/components/onboarding/DroppoLogo.vue";


@Component({
  name: 'HowItWorks',
  components: {
    DroppoLogo,
  },
})
export default class HowItWorks extends Vue {
  @Prop()
  private img!: string;

  @Prop({  default: "TOP"})
  private mode!: string;

  @Prop()
  private text1!: string;

  @Prop()
  private text2!: string;

  @Prop({default: ''})
  private myClass!: string;

  private next() {
    this.$uiBus.emit("intro:next");
  }
}
